import React, { useEffect, useState } from "react";
import "./Nabar.css";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`navbars ${scrolled ? "scrolled" : ""}`}>
      <nav className="navbar navbar-expand-lg navb">
        <div className="container-fluid p-0">
          <h1 className="navbar-logo">
            <b>ECL (SINGAPORE) PTE. LTD.</b>
          </h1>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="navbar-nav ms-auto">
              <Link className="nav-links" to="/">
                <i className="fa-solid fa-house"></i>
                {props.Home}
              </Link>

              <div className="nav-item dropdown">
                <a
                  className="nav-links dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <i className="fa-solid fa-circle-info"></i>
                  {props.About}
                </a>

                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/about">
                      {props.Fleet}
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/pctc">
                      {props.PCTC}
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="nav-item dropdown">
                <a
                  className="nav-links dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <i className="fa-regular fa-calendar"></i>
                  {props.More}
                </a>

                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/intra-asia">
                      {props.IntraAsia}
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Bay-of-Bengal">
                      {props.Bay_Bengal}
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/pctc2">
                      {props.PCTC2}
                    </Link>
                  </li>
                </ul>
              </div>

              <Link className="nav-links" to="/contact">
                <i className="fa-solid fa-address-book"></i>
                {props.Contact}
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
